module.exports = __webpack_public_path__ + "img/icon_map_water_zaixian1.b9ace144.svg";